import styled from "styled-components";
import Breadcrumb from "../breadcrumb";
import BackgroundWrapper from "../BackgroundWrapper";

const PageHeader = ({ pageHeader, section, location }) => {
  const isTitleCase = pageHeader?.headerTextFormat === "titleCase";

  //TODO: fix this to use section slug for a href link
  return (
    <BackgroundWrapper
      tag="section"
      image={pageHeader?.image}
      section={section}
      isTitleCase={isTitleCase}
      pageHeader={pageHeader}
    >
      <div
        className={`flex flex-wrap ${
          isTitleCase ? "items-start" : "item-center"
        }`}
      >
        <div className="w-full">
          <div
            className={` ${isTitleCase ? "w-full md:w-5/12" : ""} text-white`}
          >
            {pageHeader?.showBreadcrumb === false ? (
              <hr className="w-8 border-yellow-500 border-4 mb-2" />
            ) : (
              <nav className="mb-1" aria-label="Breadcrumb" role="navigation">
                <h2 className="sr-only">Breadcrumb</h2>
                <ol className="list-none p-0 inline-flex">
                  <li className="hidden sm:flex items-center m-breadcrumb">
                    <a
                      href={
                        section?.urlPrefix
                          ? section.urlPrefix
                          : section?.sectionSlug?.current
                          ? section.sectionSlug.current
                          : "/"
                      }
                      title="Rollins College Home"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="inline-block w-6 hover:ring"
                        viewBox="0 0 141 135"
                      >
                        <title>Rollins College</title>
                        <desc>Home</desc>
                        <defs>
                          <polygon points="0 0.2 140.5 0.2 140.5 134.3 0 134.3" />
                          <polygon points="0 0.2 140.5 0.2 140.5 134.3 0 134.3" />
                        </defs>
                        <g fill="none">
                          <mask className="a">
                            <use xlinkHref="#path-1" />
                          </mask>
                          <polyline
                            mask="url(#mask-2)"
                            points="49.1 37.7 49.1 56.4 87.5 56.4 93.6 51.5 93.6 41.7 89.5 37.7 49.1 37.7"
                            style={{ fill: "#0071ba" }}
                          />
                          <mask className="a">
                            <use xlinkHref="#path-3" />
                          </mask>
                          <path
                            d="M127.7 121.5L101.1 121.5 77.5 79.2 49.2 79.2 49.2 97.9 55.9 97.9 55.9 121.5 12.8 121.5 12.8 97.9 19.5 97.9 19.5 36.9 12.8 36.9 12.8 13 104.6 13 124 31.1 124 61.4 106.6 75.1 120.3 97.9 127.7 97.9 127.7 121.5ZM136.8 67.6L136.8 25.6 109.7 0.2 0 0.2 0 49.8 6.7 49.8 6.7 85.1 0 85.1 0 134.3 68.7 134.3 68.7 92 70 92 93.6 134.3 140.5 134.3 140.5 85.1 127.5 85.1 123.4 78.2 136.8 67.6Z"
                            mask="url(#mask-4)"
                            style={{ fill: "#0071ba" }}
                          />
                          <path
                            d="M93.8 51.4L87.8 56.2 49.3 56.2 49.3 37.6 89.7 37.6 93.8 41.6 93.8 51.4ZM106.8 74.9L124.3 61.2 124.3 31.1 104.9 13 13 13 13 36.8 19.7 36.8 19.7 97.5 13 97.5 13 121 56.1 121 56.1 97.5 49.4 97.5 49.4 78.9 77.7 78.9 101.3 121 128 121 128 97.5 120.5 97.5 106.8 74.9 106.8 74.9Z"
                            fill="#FACF00"
                          />
                        </g>
                      </svg>
                    </a>
                    <svg
                      className="hidden sm:block fill-current text-white w-3 h-3 mx-3"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 320 512"
                    >
                      <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
                    </svg>
                  </li>
                  <Breadcrumb nodes={pageHeader?._rawParentPage} />
                </ol>
              </nav>
            )}

            {isTitleCase ? (
              <h1
                className={`font-bold tracking-tighter text-4xl text-white mb-6 md:text-6xl`}
                style={{
                  textAlign:
                    pageHeader?.titleHorizontalAlignment === "center"
                      ? `center`
                      : `inherit`,
                }}
              >
                {pageHeader.title}
              </h1>
            ) : (
              <StyledH1
                className={`font-serif uppercase tracking-tight text-white leading-none text-6xl`}
                style={
                  pageHeader?.titleHorizontalAlignment === "center"
                    ? { textAlign: `center` }
                    : { textAlign: `inherit` }
                }
              >
                {pageHeader?.title}
              </StyledH1>
            )}
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
};

const StyledBackgroundSection = styled(PageHeader)`
  width: 100%;
`;
const StyledH1 = styled.h1`
  @media (min-width: 768px) {
    font-size: 6.5rem;
  }
`;

export default StyledBackgroundSection;
